module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-3d-d58bece42babed97cc614f4f6c17585f.svg";